<template>
  <div>
    <slot name="before" />
    <q-input v-if="link" :bg-color="inputBgColor" filled label="Zubie Location Link" :model-value="link" readonly>
      <template v-slot:after>
        <CopyButton
          :class="{
            [`bg-${buttonColor}`]: buttonColor,
            [`text-${buttonTextColor}`]: buttonTextColor,
          }"
          :text="link"
          :tooltip-classes="tooltipClasses"
        />
      </template>
    </q-input>
  </div>
</template>

<script setup lang="ts">
import CopyButton from 'components/CopyButton.vue';

defineProps<{
  buttonColor?: string;
  buttonTextColor?: string;
  inputBgColor?: string;
  link: string;
  tooltipClasses?: string;
}>();
</script>
